import styled from "styled-components";

const HorizontalSpace = styled.div`
  margin-left: ${({ $amount }) => $amount}px;
`;

export default HorizontalSpace;
